import { Component, HostBinding, ViewEncapsulation } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

@Component({
  selector: 'form-checkbox-field',
  standalone: false,
  encapsulation: ViewEncapsulation.None,
  styles: [
    `
      .form-checkbox-field {
        display: flex;
        flex-direction: column;

        .toggle-label {
          pointer-events: none;
          top: var(--p-iftalabel-top);
          transition-property: all;
          transition-timing-function: ease;
          line-height: 1;
          font-size: var(--p-iftalabel-font-size);
          font-weight: var(--p-iftalabel-font-weight);
          inset-inline-start: var(--p-iftalabel-position-x);
          color: var(--p-iftalabel-color);
          transition-duration: var(--p-iftalabel-transition-duration);
          margin-bottom: 0.5rem;
        }
      }
    `,
  ],
  template: `
    <div style="display: flex;gap: 10px;">
      <p-checkbox
        [formControl]="formControl"
        [binary]="true"
        [ariaLabelledBy]="field.id + '_label'"
      />
      <span [id]="field.id + '_label'">
        <ng-container *ngIf="isDefined(field?.props?.['label'])">
          {{
            field.props['translate']
              ? (field.props['label'] ?? '|' | translate)
              : (field.props['label'] ?? '|')
          }}
        </ng-container>
      </span>
    </div>
  `,
})
export class FormCheckboxFieldType extends FieldType<FieldTypeConfig> {
  @HostBinding('class')
  readonly cssClass = 'form-checkbox-field';

  isDefined(value: undefined | string): boolean {
    return value !== undefined && value !== '';
  }
}
